import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class EnableJobsiteDropdownRepearOrder implements IFlagFeature {
  name = Features.ENABLED_JOBSITE_DROPDOWN_REPEAT_ORDER;
  constructor() {}
  public isEnabled(container?: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
